import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { parseZone } from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  buid;
  empGuid;
  officeGuid;
  startTime;
  endTime;
  view;
  timeZone: string;

  constructor(private http: HttpClient) {
    this.buid = this.getQueryStringValue('buid');
    this.empGuid = this.getQueryStringValue('empGuid');
    this.startTime = this.getQueryStringValue('startTime');
    this.endTime = this.getQueryStringValue('endTime');
    this.officeGuid = this.getQueryStringValue('officeGuid');
    this.view = this.getQueryStringValue('view');
  }

  getLayout(timeZone, office, date, floor, filtersArray, searchDetails) {
    let start = this.getTimeZoneSpecificDateTimeAtDayHorizon(timeZone, 'start', date);
    let end = this.getTimeZoneSpecificDateTimeAtDayHorizon(timeZone, 'end', date);
    let floorPremiseId = this.getQueryStringValue('floorId');
    if (!this.startTime && !this.endTime) {
      this.startTime = start.getTime();
      this.endTime = end.getTime();
    }
    if (!searchDetails) {
      if (this.view === 'admin-view') {
        return this.http.get(`${window.location.href}/office/floors/${this.buid}/${office}?startTime=${start.getTime()}&endTime=${end.getTime()}&floorPremiseIds=${floor}`);
      } else if (this.view === 'seat-assignment-view') {
        return this.http.get(`${window.location.href}/office/floors/floorplanWithoutBooking/${this.buid}?floorPremiseId=${floorPremiseId}&startTime=${this.startTime}`);
      } else {
        return this.http.post(`${window.location.href}/office/plan/${this.buid}/premise/v2?empGuid=${this.empGuid}&startTime=${this.startTime}&endTime=${this.endTime}&officeGuid=${this.officeGuid}`, filtersArray);
      }
    } else {
      if (this.view === 'admin-view') {
        return this.http.get(`${window.location.href}/office/floors/${this.buid}/${office}?startTime=${start.getTime()}&endTime=${end.getTime()}&floorPremiseIds=${floor}`);
      } else {
        return this.http.post(`${window.location.href}/office/plan/${this.buid}/premise/v2?empGuid=${this.empGuid}&startTime=${searchDetails[0].startTime}&endTime=${searchDetails[0].endTime}&officeGuid=${searchDetails[0].officeId}`, filtersArray);
      }
    }
  }

  getTimeZoneSpecificDateTimeAtDayHorizon(timeZone: string, horizonType: 'start' | 'end', dateTime: Date | number = Date.now()) {
    const timeZoneMoment = parseZone(dateTime).tz(timeZone);
    timeZoneMoment.date(new Date(dateTime).getDate());
    timeZoneMoment.hours(horizonType === 'start' ? 0 : 23);
    timeZoneMoment.minutes(horizonType === 'start' ? 0 : 59);
    timeZoneMoment.seconds(horizonType === 'start' ? 0 : 59);
    timeZoneMoment.milliseconds(horizonType === 'start' ? 0 : 999);
    return new Date(timeZoneMoment.format());
  }

  public getQueryStringValue(key) {
    let value = "";
    if (window.location.href) {
      const queryStringPairs = window.location.href.split('?')[1] && window.location.href.split('?')[1].split('&');
      if (queryStringPairs) {
        for (let i = 0; i < queryStringPairs.length; i++) {
          const pair = queryStringPairs[i].split('=');
          if (pair[0] === key) {
            value = pair[1];
            break;
          }
        }
      }
      return value;
    }
    return '';
  }

  getFloorImage(buid, fileName) {
    return this.http.get(`${window.location.href}/office/floorbackground/${buid}/${fileName}`, { responseType: 'blob' });
  }

  getPreviewLayout(excelData: any) {
    return this.http.post(`${window.location.href}/office/csv/upload/verify?floorPlanAvailable=true&premiseId=asdasd`, excelData);
  }

  getOffices(){
    return this.http.get('https://bookingreqstage.moveinsync.com:8095/booking-rule-engine/dashboard/qa-Test/filter/EMqaTest-$000-0000-0000-000000000001/list')
  }

  getFloors(officeGuid){
    return this.http.get('https://staging2.moveinsync.com/employee-exp/office/floors/list/qa-Test/'+officeGuid)
  }

  getLayoutForFloor(floorId, officeId){
    return this.http.post('https://wisbff-stag.moveinsync.com/seat-booking/seats/available/qa-Test?empGuid=EMqaTest-$000-0000-0000-000000000001',{
        "amenities":[],
        "floorPremiseIds":[floorId],
        "officeGuid":officeId,
        "startTime":"1618442100000",
        "endTime":"1618512300000"
    })
  }

}
